export enum MediaThreshold {
    GADGET = '(max-width:370px)',
    MOBILE = '(max-width:639px)',
    TABLET = '(min-width:640px) and (max-width:939px)',
    DESKTOP = '(min-width:940px)'
}
